document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector(".rent-buy-section-block");
  if (!container) return;

  const sections = Array.from(container.querySelectorAll(".form-section"));

  const sectionData = sections.map(section => ({
    section,
    content: section.querySelector(".form-content"),
    contentInner: section.querySelector(".form-inner")
  }));

  sectionData.forEach(({ content, contentInner }) => {
    if (!content || !contentInner) return;

    syncToContentSize(content, contentInner);

    const observer = new MutationObserver(() => {
      clearTimeout(observer.debounceTimer);
      observer.debounceTimer = setTimeout(() => {
        syncToContentSize(content, contentInner);
      }, 50);
    });

    observer.observe(contentInner, { 
      childList: true, 
      subtree: true,
      attributes: true,
      characterData: true
    });

    ['load', 'input', 'change', 'blur'].forEach(eventType => {
      contentInner.addEventListener(eventType, () => {
        setTimeout(() => syncToContentSize(content, contentInner), 100);
      }, true);
    });

    window.addEventListener('resize', () => {
      clearTimeout(observer.resizeTimer);
      observer.resizeTimer = setTimeout(() => {
        syncToContentSize(content, contentInner);
      }, 100);
    });
  });

  function syncToContentSize(content, inner) {
    const newHeight = inner.scrollHeight;
    
    requestAnimationFrame(() => {
      content.style.minHeight = `${newHeight}px`;
      inner.style.minHeight = `${newHeight}px`;
    });
  }
});